import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API } from '../../api';

@Injectable({
    providedIn: 'root'
})
export class ProductFamilyService {
    private url: string = API + '/family';

    constructor(private http: HttpClient) { }

    getProductFamilies(): Observable<any> {
        return this.http.get(this.url);
    }
}
